import { Link } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { useLoginPath } from './useLoginPath'

export const LoginLink = ({ children }: { children: React.ReactNode }) => {
  const loginPath = useLoginPath()
  return <Link to={loginPath}>{children}</Link>
}
